import { useState } from "react";
import formStyle from "../form.module.css";
import { X } from "lucide-react";

interface Props {
  submit: (joinToken: string) => void;
  close?: () => void;
}

function NewPentestForm({ submit, close }: Readonly<Props>) {
  const [formState, setFormState] = useState<string>("");

  function preventedSubmit(event: React.FormEvent, data: string) {
    event.preventDefault();
    submit(data);
  }

  return (
    <form onSubmit={(event: React.FormEvent) => preventedSubmit(event, formState)} className={formStyle.formWrapper}>
      <div className={formStyle.fieldsWrapper}>
        <h5 className={formStyle.firstLabel + " " + formStyle.requiredField}>{"Enter Invite Token"}</h5>
        <input
          className={formStyle.inputField}
          type={"text"}
          required
          value={formState}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setFormState(e.currentTarget.value);
          }}
        />
      </div>

      <button type="submit" className={formStyle.submitButton}>
        Join
      </button>
      {close && (
        <button className={formStyle.closeButton} onClick={close}>
          <X stroke="var(--onedark-text)" strokeWidth="1.5" />
        </button>
      )}
    </form>
  );
}

export default NewPentestForm;
